import AccessibleFeature from './Accessible';
import ExtensibleFeature from './Extensible';
import InteractionFeature from './Interaction';
import AnimationFeature from './Animation';

const Features = {
  Accessible: AccessibleFeature,
  Extensible: ExtensibleFeature,
  Interaction: InteractionFeature,
  Animation: AnimationFeature,
};

export default Features;
